import type { CashOutQuote } from '../../types/cashoutQuotes';
import type { MyBetsState } from '../../types/myBets';

const cashoutQuotesUpdated = (
  state: MyBetsState,
  payload: Record<string, CashOutQuote>
): MyBetsState => ({
  ...state,
  cashoutQuotes: payload
});

export default cashoutQuotesUpdated;
